export namespace PermissionsEnum {
  export enum UseCase {
    //#region 预算管理[UseCaseGroupID=11]

    // 总部预算
    BUDGET_HQ = 1102,

    // 专项项目
    BUDGET_PROJECT = 1105,

    // 总部预算(广告)
    BUDGET_HQ_MKT = 1122,

    //#endregion

    //#region 预排档管理[UseCaseGroupID=12]

    //#endregion

    //#region 政策管理[UseCaseGroupID=14]

    // 产品政策
    PRODUCT_POLICY = 1402,

    //#endregion

    //#region 活动管理[UseCaseGroupID=16]


    // 活动申请
    SA = 1602,

    // 活动结案
    SS = 1605,

    // 活动核销
    SP = 1608,

    // 预付申请
    PP = 1611,

    //#endregion

    //#region 广告活动管理[UseCaseGroupID=17]

    // 活动申请(广告)
    SA_MKT = 1702,

    // 活动核销(广告)
    SP_MKT = 1708,

    //#endregion

    //#region 客户管理[UseCaseGroupID=18]

    // 一级客户合同
    SALES_CONTRACT = 1802,

    // 二级客户合同
    SALES_CONTRACT_INDIRECT = 1803,

    // 合同返利单
    REBATE_INFO = 1805,

    // 合同返利报销
    RSP = 1808,

    // 一级客户合同销售目标
    SALES_TARGET_CONTRACT = 1811,

    // 二级客户合同销售目标
    SALES_TARGET_CONTRACT_INDIRECT = 1812,

    // 客户
    SOLD_TO = 1815,

    // 客户销售目标
    SALES_TARGET = 1818,

    // 客户回款目标
    SALES_TARGET1 = 1819,

    // 收货地
    SHIP_TO = 1821,

    //售达方主户
    SOLD_TO_MASTER = 1824,

    // 返利客户组
    SOLD_TO_GROUP = 1827,

    // 客户分类
    CUST_TYPE = 1829,

    // 客户组补全
    CUST_SYS_ADD = 1830,

    //ERP客户
    SOLD_TO_REAL = 1833,

    //门店
    SHOP = 1836,

    //回款结转补入
    SELLIN2 = 1839,

    // 用户客户关系
    STAFF_AND_SOLD_TO = 1845,

    //#endregion

    //#region 财务操作[UseCaseGroupID=22]

    // 费用类别
    EC = 2202,
    // 费用类别科目映射
    EC_ACCOUNT_MAPPING = 2203,

    // 费用类别(广告)
    EC_MKT = 2205,
    // 费用类别(广告)科目映射
    EC_MKT_ACCOUNT_MAPPING = 2206,

    // 使用部门
    BO = 2208,

    // 费用归属
    BOHQ = 2211,

    // 财务设置
    PERIOD_CONFIG = 2214,

    // 业务预提
    ACCRUAL = 2217,

    // 业务预提(广告)
    ACCRUAL_MKT = 2218,

    // 发票管理
    INVOICE = 2220,

    //科目
    ACCOUNT = 2223,
    //明细科目
    ACCOUNT_DETAIL = 2226,


    //发票抵扣公司(无此useCae 有引用先保留)
    BRANCH_COMPANY = -1,

    // 预提手工调整
    EXPENSE_NON_TPM = 2230,

    // 预提手工调整(广告)
    EXPENSE_MKT_NON_TPM = 2233,

    // 税率类型
    VAT_TYPE = 22250,

    // 账单费用
    EXPENSE_BILL = 2239,

    //#endregion

    //#region 基础数据[UseCaseGroupID=25]

    // 系统公告
    ANNOUNCEMENT = 2502,

    // 产品
    PRODUCT = 2505,

    // 产品底价管理
    PRODUCT_PRICE_BOTTOM = 2508,

    // 产品标准售价
    PRODUCT_PRICE_POS = 2509,

    // 产品统一价
    PRODUCT_UNIFORM_PRICE = 2514,

    // 促销形式
    PROMOTION_TYPE = 2512,

    //档期类型
    SCHEDULE_TYPE = 2513,

    //通路类型
    TRADE_TYPE = 2516,

    //供应商
    SUPPLIER = 2519,

    //审批拒绝原因
    REJECT_REASON = 2525,

    //财务审批人
    BO_APPROVER = 2528,

    //商品类型映射
    CRM_PRODUCT_TYPE_MAPPING = 2530,

    //特殊审批人(总部)
    WF_APPROVER_HQ = 2535,

    //特殊审批人(区域)
    WF_APPROVER_REGION = 2537,
    //特殊审批人(费用项品牌)
    WF_APPROVER_EC_PRODUCT = 2541,

    //#endregion

    //#region 系统管理[UseCaseGroupID=81]

    // 组织结构
    DEPT = 8102,

    // 用户管理
    STAFF = 8105,

    // 系统角色
    SYSTEM_ROLE = 8108,

    // 审批角色
    WORKFLOW_ROLE = 8111,

    // 流程设置
    INDEX = 8114,

    // 任务日志
    SERVICE_LOG = 8117,

    // 操作日志
    OPTION_LOG = 8120,

    // 登陆日志
    LOGIN_ACTION_LOG = 8123,

    // 经销商登陆日志
    SOLD_TO_LOGIN_ACTION_LOG = 8126,

    // 业务代理
    AGENT_BUSINESS = 8129,

    // 代理审批
    SUPER_AGENT_APPROVER = 8132,

    // 帮助中心
    HELP_CENTER = 8135,

    // 错误处理
    ERROR_HANDlING = 8138,

    //#endregion

    //#region 系统配置[UseCaseGroupID=83]

    // 表单类型
    PAGE_TYPE = 8302,

    // 计划任务
    SERVICE = 8305,

    // 提醒规则设置
    REMIND_TYPE = 8308,

    // 审批时效设置
    FORM_TYPE = 8311,

    // 系统参数设置
    PARAMETER = 8314,

    // 错误信息设置
    ERROR_CONFIGURATION = 8317,

    //数据字典
    USER_DATA_OPTIONS = 8320,

    //#endregion

    //#region 个人配置[UseCaseGroupID=85]

    // 代理审批
    AGENT_APPROVE = 8502,

    // 批量审批
    BATCH_APPROVE = 8505,

    //#endregion

    //#region 数据分析[UseCaseGroupID=91]

    // 总部预算分析
    REPORT_BUDGET = 9102,

    // 专项项目分析
    REPORT_MULTI_PROJECT = 9105,

    // 预提入账明细
    REPORT_ACCRUAL = 9108,

    // 活动明细报告
    REPORT_ACTIVITY = 9111,

    // 核销明细报告
    REPORT_PAYMENT = 9114,

    // 年度合同费用明细
    REPORT_CONTRACT = 9117,

    // 总部预算调整明细
    REPORT_BUDGET_ADJUST = 9120,

    // SAP发货销量明细
    REPORT_SAP_DELIVERY = 9123,

    // 门店销量明细
    REPORT_SHOP_SALES_QUANTITY = 9126,

    // 审批时效明细报告
    REPORT_FORM_TYPE = 9129,

    // IO预提明细报告
    REPORT_FOR_BUDGET_IO_ACCRUAL = 9155,

    //#endregion

    // ======================== DMS 相关useCase start ========================

    /**
     * 经销商用户管理
     */
    SOLD_TO_USER = 8139,

    // ======================== DMS 相关useCase end ========================

    //#region 电子档案管理[UseCaseGroupID=255]

    // 电子档案单据导出
    FORM_EXPORT_ARCHIVE = 2550,

    //#endregion

    //#region 本项目不再使用

    //#endregion
  }

  export enum OperateType {
    /**
     * 填单，申请（指各种表单的申请，包括活动、专项等等任何表单）
     */
    APPLY = 1,
    /**
     * 查询（和权限范围相关）
     */
    QUERY = 2,
    /**
     * 查看（和权限范围无关的，指基础数据）
     */
    VIEW = 3,
    /**
     * 维护（指增删改）
     */
    MAINTAIN = 4,
    /**
     * 作废（指单据的作废）
     */
    SCRAP = 5,
    /**
     * 关闭（活动或者返点单的关闭）
     */
    CLOSE = 6,
    /**
     * 重新打开（活动或者专项的重新打开）
     */
    RE_OPEN = 7,
    /**
     * 补入（专指合同返利单的补入）
     */
    ADD = 8,
    /**
     * 导入（目前导入都和维护或者申请合在一起的，未来可扩展）
     */
    IMPORT = 9,
    /**
     * 导出（一般不单独列出，有些涉及性能的导出则需要特别列出）
     */
    EXPORT = 10,
    /**
     * 解除导出锁定（一般用于核销单）
     */
    REMOVE_LOCK = 11,
    /**
     * 发货完成
     */
    COMPLETE_DELIVERY = 12,
    /**
     * 解除发货完成
     */
    RE_DELIVERY = 13,
    /**
     * 修改支付方式
     */
    MODIFY_PAYMENT_METHOD = 14,
    /**
     * 修改金额（一般是修改核销单的金额，本项目修改结案金额也使用）
     */
    MODIFY_AMOUNT = 15,
    /**
     * 手动结案（专指合同返利单的手动结案）
     */
    MANUAL_SETTLE = 16,
    /**
     * 取消价格折扣
     */
    CANCEL_PD = 17,
    /**
     * 一级合同返利生成
     */
    GENERATE_REBATE = 18,
    /**
     * 二级合同返利生成
     */
    GENERATE_REBATE_INDIRECT = 19,
    /**
     * 政策返利生成
     */
    GENERATE_REBATE_POLICY = 51,
    /**
     * 确认
     */
    CONFIRM = 52,
    /**
     * 政策返利补入
     */
    ADD_REBATE_POLICY = 54,
    /**
     * 匹配政策返利单
     */
    MATCH_REBATE_POLICY = 55,
    /**
     * 查看受限审批意见
     */
    REMARK_NEED_PERMISSION = 58,

    /**
     * 申请随货特价
     */
    APPLY_PD_DISCOUNT = 61,

    /**
     * 申请随货搭赠
     */
    APPLY_PD_BUY_GIVE = 62,
    /**
     * 只维护非成品
     */
    NON_FINISHED_PRODUCTS = 63,

    /**
     * 账单费用确认
     */
    EXPENSE_BILL_CONFIRM = 64,


    /**
     * 查看客户大区分析
     */
    VIEW_SOLD_LEVEL1 = 71,
    /**
     * 查看客户省办分析
     */
    VIEW_SOLD_LEVEL2 = 72,
    /**
     * 查看客户市办分析
     */
    VIEW_SOLD_LEVEL3 = 73,
    /**
     * 查看区域大区分析
     */
    VIEW_REGION_LEVEL1 = 81,
    /**
     * 查看区域省办分析
     */
    VIEW_REGION_LEVEL2 = 82,
    /**
     * 查看区域市办分析
     */
    VIEW_REGION_LEVEL3 = 83,
  }
}
